<template>
    <div class="body d-flex py-lg-3 py-md-2 mb-5">
        <div class="container-xxl">
            <h1 class="fw-bold page-title d-none">Εκπαιδευτικό υλικό</h1>
            <div class="row clearfix">
                <div class="shadow py-4 my-3 px-3 rounded">
                    <h2 class="text-primary fw-bold">Tutorials</h2>
                    <hr>
                    <div class="row text-center gap-2">
                        <div class="col">
                            <div>
                                <iframe width="100%" height="420"
                                    src="https://www.youtube.com/embed/ys0hhQVhE0A?si=a9mSpU5h27qgY7G2"
                                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-
                                    write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-
                                    when-cross-origin" allowfullscreen></iframe>
                            </div>
                        </div>
                        <div class="col">
                            <div>
                                <iframe width="100%" height="420" src="https://www.youtube.com/embed/LXioTCnYcW8?si=OHKTbSZUFVwP2rdu" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

                            </div>
                        </div>
                        <!-- <div class="col">
                            <div style="width: 100%;">
                                <video src="../assets/images/promo/login-and-functionalities-admin-mun.webm" width="100%" controls></video>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'vue-toastification/dist/index.css';

export default {
    metaInfo: {
        title: 'Πρωοθητικό υλικό',
        meta: [
            { name: 'description', content: 'Πρωοθητικό υλικό' },
            { property: 'og:title', content: 'Πρωοθητικό υλικό' },
            { property: 'og:description', content: 'Πρωοθητικό υλικό' }
        ]
    }
};
</script>

<style scoped></style>
